import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import CheckBoard from './CheckBoard';
import { handleFocus } from './interaction';
// interface SwatchProps {
//   color: string;
//   style: any;
//   onClick: (color: string, event: MouseEvent<HTMLDivElement>) => void;
//   onHover?: (color: string, event: Event) => void;
//   title: string;
//   focus: boolean;
//   focusStyle: any;
//   children: ReactNode;
// }
const styles = {
    height: '100%',
    width: '100%',
    cursor: 'pointer',
    position: 'relative',
    outline: 'none',
};
export const Swatch = ({ color, style, onClick, onHover, title = color, children, focus, focusStyle = {}, }) => {
    const transparent = color === 'transparent';
    const handleClick = useCallback((e) => onClick?.(color, e), [color, onClick]);
    const handleKeyDown = useCallback((e) => {
        if (e.key.toLowerCase() === 'enter') {
            onClick?.(color, e);
        }
    }, [color, onClick]);
    const handleHover = useCallback((e) => onHover?.(color, e), [color, onHover]);
    const optionalEvents = {};
    if (onHover) {
        optionalEvents.onMouseOver = handleHover;
    }
    return (_jsxs("div", { style: {
            ...styles,
            background: color,
            ...style,
            ...(focus ? focusStyle : {}),
        }, onClick: handleClick, title: title, tabIndex: 0, onKeyDown: handleKeyDown, ...optionalEvents, children: [children, transparent && (_jsx(CheckBoard, { borderRadius: style.borderRadius, boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)" }))] }));
};
export default handleFocus(Swatch);
//# sourceMappingURL=Swatch.js.map